export const facilityData = {
    facilityCode : 1001,
    facilityName : '京都府漁業協同組合',
    logoUrl      : '/images/logo-s.svg'
}

export const authorityList = [
    { id: '1', name: 'システム管理者' },
    { id: '2', name: '漁協ユーザ' },
    { id: '3', name: '一般ユーザ' },
]

export const styleList = [
    { id: '1', name: 'D' },
    { id: '2', name: '箱' },
]

export const kgDivision = [
    { id: '1', name: 'Kg代' },
    { id: '0', name: '箱代' },
]

export const fishStyleList = [
    { id: '8', name: '鮮魚' },
    { id: '81', name: '活〆' },
    { id: '3', name: '活魚' },
]

export const bidUnitList = [
    { id: '1', name: '全量' },
    { id: '2', name: 'Kg' },
    { id: '3', name: 'D' },
    { id: '4', name: '箱' },
    { id: '5', name: '匹' },
]